// import React, { useEffect } from "react";
// import "./Footer.css";
// import Skills from "../../src/assets/img/logo.png";
// import SkillsLogo from "../../src/assets/img/SkillGigs_tm-black 4.svg";
// import Facebook from "../../src/assets/img/facebook-fill.svg";
// import LinkedIn from "../../src/assets/img/linkedin-fill.svg";
// import moment from "moment";
// import { TwitterOutlined } from "@ant-design/icons";
// import { InstagramOutlined } from "@ant-design/icons";
// import HandSvg from "../assets/icons/hand-right.svg";
// import { BsFacebook, BsLinkedin, BsSpotify, BsYoutube } from "react-icons/bs";

// import {
//   FacebookOutlined,
//   LinkedinOutlined,
//   DownOutlined,
//   UpOutlined,
// } from "@ant-design/icons";
// import { useState } from "react";

// const Footer = (props) => {
//   const [variable1, setVariable1] = useState("up-1");
//   const [variable2, setVariable2] = useState("up-2");
//   const [variable3, setVariable3] = useState("up-3");
//   const [windowDimensions, setWindowDimensions] = useState(
//     getWindowDimensions()
//   );

//   const [width, setWidth] = useState(false);

//   useEffect(() => {
//     function handleResize() {
//       setWindowDimensions(getWindowDimensions());
//     }

//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   function getWindowDimensions() {
//     const { innerWidth: width, innerHeight: height } = window;
//     return {
//       width,
//       height,
//     };
//   }

//   useEffect(() => {
//     if (windowDimensions.width > 768) {
//       setVariable1("up-1");
//       setVariable2("up-2");
//       setVariable3("up-3");
//     }

//     // console.log("dimensions++++++++", windowDimensions)
//   }, [windowDimensions, variable1, variable2, variable3]);

//   return (
//     <div className="footer-wrapper-div">
//       <div className="Columns">
//         <div className="About">
//           <div className="ArrowDiv">
//             <div
//               style={{ fontWeight: "500", fontSize: "0.95rem", color: "black" }}
//               className="item"
//             >
//               About
//             </div>
//             {variable1 === "down-1" && (
//               <DownOutlined
//                 className="DownArrow"
//                 onClick={() => {
//                   setVariable1("up-1");
//                 }}
//               />
//             )}
//             {variable1 === "up-1" && (
//               <UpOutlined
//                 className="UpArrow"
//                 onClick={() => {
//                   setVariable1("down-1");
//                 }}
//               />
//             )}
//           </div>

//           {variable1 == "up-1" && (
//             <div>
//               <div className="item">
//               <a  href={`${process.env.REACT_APP_MY_URL}/about-us`}>
//                   <p style={{ color: "grey" }} > About SG</p>
//                 </a>
//                </div>
//               <div className="item" style={{ width: "15rem" }}>
//                 Press & News - goes to blogs
//               </div>
//               <div className="item">
//                 <a  href={`${process.env.REACT_APP_MY_URL}/privacy-policy`}>
//                   <p style={{ color: "grey" }}> Privacy policy </p>
//                 </a>
//               </div>
//               <div className="item">
//                 <a   href={`${process.env.REACT_APP_MY_URL}/terms-of-service`}>
//                   <p style={{ color: "grey" }} >Terms of services</p>
//                 </a>
//               </div>
//             </div>
//           )}
//         </div>

//         <div className="Support">
//           <div className="ArrowDiv-1">
//             <div
//               style={{ fontWeight: "500", fontSize: "0.95rem", color: "black" }}
//               className="item"
//             >
//               Support
//             </div>
//             {variable2 === "down-2" && (
//               <DownOutlined
//                 className="DownArrow"
//                 onClick={() => {
//                   setVariable2("up-2");
//                 }}
//               />
//             )}
//             {variable2 === "up-2" && (
//               <UpOutlined
//                 className="UpArrow"
//                 onClick={() => {
//                   setVariable2("down-2");
//                 }}
//               />
//             )}
//           </div>
//           {variable2 === "up-2" && (
//             <div>
//               <div className="item">FAQ</div>
//             </div>
//           )}
//         </div>
//         <div className="Community">
//           <div className="ArrowDiv-2">
//             <div
//               style={{ fontWeight: "500", fontSize: "0.95rem", color: "black" }}
//               className="item"
//             >
//               Community
//             </div>
//             {variable3 === "down-3" && (
//               <DownOutlined
//                 className="DownArrow"
//                 onClick={() => {
//                   setVariable3("up-3");
//                 }}
//               />
//             )}
//             {variable3 === "up-3" && (
//               <UpOutlined
//                 className="UpArrow"
//                 onClick={() => {
//                   setVariable3("down-3");
//                 }}
//               />
//             )}
//           </div>
//           {variable3 === "up-3" && (
//             <div>
//               <div className="item">Events</div>
//               <div className="item">
//               <a   href={`${process.env.REACT_APP_MY_URL}/blog`}>
//                   <p style={{ color: "grey" }} >Blogs</p>
//                 </a>
//                 </div>
//               <div className="item">Invite a friend</div>
//             </div>
//           )}
//         </div>
//       </div>
//       {/* <hr className='line1' /> */}
//       <div className="Footers">
//         <div className="skillgigs">
//           <div className="logo">
//             <img src={SkillsLogo} />
//           </div>
//           <div className="para">
//             © SkillGigs International Ltd. {moment().year()}
//           </div>
//         </div>
//         <div className="icons2">
//           <a href="https://twitter.com/skillgigsonline?lang=en" target="_blank">
//             <span>
//               <TwitterOutlined
//                 style={{ marginTop: "1px", marginRight: "-2.5px" }}
//               />
//             </span>
//           </a>
//           <a href="https://www.facebook.com/skillgigsonline/" target="_blank">
//             <BsFacebook className="footer-icon-modification" />
//           </a>
//           <a href="https://www.linkedin.com/company/skillgigs" target="_blank">
//             <span>
//               <BsLinkedin className="footer-icon-modification" />
//             </span>
//           </a>
//           <a href="https://www.instagram.com/skillgigs" target="_blank">
//             <span>
//               <InstagramOutlined />
//             </span>
//           </a>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Footer;

import React, { useEffect, useState } from "react";
import {
  DownOutlined,
  InstagramOutlined,
  TwitterOutlined,
  UpOutlined,
} from "@ant-design/icons";
import { Col, Divider, Row } from "antd";
import { BsFacebook, BsLinkedin, BsSpotify, BsYoutube } from "react-icons/bs";
import { useHistory, useLocation } from "react-router-dom";
import Logo2 from "../assets/icons/Logo2.svg";

import "./Footer.css";

const Footer = () => {
  const history = useHistory();
  const location = useLocation();
  const [dimensions, setDimensions] = useState(window.innerWidth);
  const [ListOfAbout, SetListOfAbout] = useState(false);
  const [ListOfSupport, SetListOfSupport] = useState(false);
  const [ListOfCommunity, SetListOfCommunity] = useState(false);
  const [ListOfMoreFromUs, SetListOfMoreFromUs] = useState(false);
  const initialPaths = useLocation().pathname.split("/")[1];
  const [route, setRoute] = useState(initialPaths);

  // console.log("paths", location.pathname);
  const About = (
    <>
      {/* <span
        className="footer-first-span"
        // onClick={() => window.location.replace("/about-us")}
        onClick={() => window.open('https://skillgigs.com/about-us/')}
        // onClick={() => history.push('/skillgigs.com/about-us')}
      >
        About SG
      </span> */}
      <a
        href="https://skillgigs.com/about-us/"
        className="footer-link-custom"
        target="_blank"
      >
        <span
          className="footer-first-span"
          // onClick={() => window.location.replace("/about-us")}
          // onClick={() => history.push('/skillgigs.com/about-us')}
        >
          About SG
        </span>
      </a>
      <a
        href="https://skillgigs.com/how-it-works/"
        target="_blank"
        className="footer-link-custom"
      >
        <span
        // onClick={() => window.location.replace("/how-it-works/")}
        // onClick={() => window.open("https://skillgigs.com/how-it-works/")}
        >
          How it works
        </span>
      </a>

      {/* <span
        onClick={() => {
          window.location.replace("/employers/");
        }}
        >
        Employers
      </span> */}
      <a
        href="https://skillgigs.com/careers/"
        className="footer-link-custom"
        target="_blank"
      >
        <span
        // onClick={() => {
        //   window.location.replace("/careers/");
        // }}
        // onClick={() => window.open("https://skillgigs.com/careers/")}
        >
          Corp Careers
        </span>
      </a>
      {/* <span
        onClick={() => {
          history.push("/dummy");
        }}
        >
        Investor relations
      </span> */}
      <a
        href="https://skillgigs.com/category/"
        className="footer-link-custom"
        target="_blank"
      >
        <span
          // onClick={() => window.open('https://skillgigs.com/careers/')}
          className="footer-bottom-span"
        >
          {/* <a > */}
          {/*relative URL */}
          Sitemap
          {/* </a> */}
        </span>
      </a>

      <a
        href="https://skillgigs.com/contact-us/"
        className="footer-link-custom"
        target="_blank"
      >
        <span className="footer-bottom-span">Contact Us</span>
      </a>
    </>
  );

  const Support = (
    <>
      <a
        href="https://skillgigs.com/terms-of-service/"
        className="footer-link-custom"
        target="_blank"
      >
        <span
          // onClick={() => {
          //   window.location.replace("/terms-of-service");
          // }}
          className="footer-first-span"
        >
          Terms of service
        </span>
      </a>

      <a
        href="https://skillgigs.com/privacy-policy/"
        className="footer-link-custom"
        target="_blank"
      >
        <span
        // onClick={() => {
        //   window.location.replace("/privacy");
        // }}
        >
          Privacy policy
        </span>
      </a>

      {/* <span
        onClick={() => {
          window.location.replace("/security/");
        }}
      >
        Security
      </span> */}

      <a
        href="https://skillgigs.com/help/"
        className="footer-link-custom"
        target="_blank"
      >
        <span
        // onClick={() => {
        //   window.location.replace("/help/");
        // }}
        >
          Help and support
        </span>
      </a>

      {/* <span
        onClick={() => {
          window.location.replace("/talent/contact-us/");
        }}
        className="footer-bottom-span"
      >
        Contact us
      </span> */}
      {/* <span
        onClick={() => {
          window.location.replace("/signup/");
        }}
      >
        Sign Up
      </span> */}
    </>
  );

  const Community = (
    <>
      {/* <span
        onClick={() => {
          history.push("/dummy");
        }}
        className="footer-first-span"
      >
        Our expectations
      </span> */}
      {/* <span
        onClick={() => {
          history.push("/dummy");
        }}
      >
        Career advice
      </span>
      <span
        onClick={() => {
          history.push("/dummy");
        }}
      >
        Business insights
      </span> */}
      <a
        href="https://skillgigs.com/blog/"
        className="footer-link-custom"
        target="_blank"
      >
        <span
        // onClick={() => {
        //   window.location.replace("/blog/");
        // }}
        >
          Blog
        </span>
      </a>

      <a
        href="https://skillgigs.com/employers/"
        className="footer-link-custom"
        target="_blank"
      >
        <span
        // onClick={() => {
        //   window.location.replace("/employers/");
        // }}
        >
          Employers
        </span>
      </a>

      <a
        href="https://skillgigs.com/guides/"
        className="footer-link-custom"
        target="_blank"
      >
        <span
        // onClick={() => {
        //   window.location.replace("/guides/");
        // }}
        >
          Guides
        </span>
      </a>

      <a
        href="https://skillgigs.com/gig-search/"
        className="footer-link-custom"
        target="_blank"
      >
        <span
          onClick={() => {
            window.location.replace("/gig-search/");
          }}
        >
          Gig search
        </span>
      </a>

      {/* <span
        onClick={() => {
          history.push("/dummy");
        }}
        className="footer-bottom-span"
      >
        Invite a friend
      </span> */}
    </>
  );

  const MoreFromUs = (
    <>
      <a
        href="https://swipefox.com/"
        className="footer-link-custom"
        target="_blank"
      >
        <span
          // onClick={() => {
          //   window.location.replace("https://swipefox.com/");
          // }}
          className="footer-first-span"
        >
          Swipefox
        </span>
      </a>

      <a
        href="https://skillgigs.com/products/"
        className="footer-link-custom"
        target="_blank"
      >
        <span
        // onClick={() => {
        //   window.location.replace("/products/");
        // }}
        >
          Our products
        </span>
      </a>

      <a
        href="https://skillgigs.com/employers/"
        className="footer-link-custom"
        target="_blank"
      >
        <span
          // onClick={() => {
          //   window.location.replace("/employers/");
          // }}
          className="footer-bottom-span"
        >
          Employer demo
        </span>
      </a>
    </>
  );

  const getPath = () => {
    try {
      return window?.location?.pathname?.split("/")[2];
    } catch (error) {
      return initialPaths;
    }
  };

  useEffect(() => {
    setRoute(getPath());
  }, [window?.location?.pathname]);

  if (
    [
      "add-candidate-email",
      "add-candidate",
      "add-candidate-name",
      "candidate-number",
      "select-gig-type",
      "gig-title",
      "candidate-skill",
      "candidate-salary",
      "message-candidate",
      "location",
      "date",
    ].includes(window?.location?.pathname?.split("/")?.[2])
  ) {
    return null;
  }

  return (
    <>
      <Divider
        className="footer-divider-top"
        aria-details={location.pathname == "/filecontainer" && "noFooter"}
      />
      <div
        className="footer-container"
        aria-details={location.pathname == "/filecontainer" && "noFooter"}
      >
        {dimensions < 768 ? (
          <>
            <div className="footer-section">
              <div className="footer-About-section">
                <div
                  onClick={() => SetListOfAbout(!ListOfAbout)}
                  className={`footer-heading ${
                    ListOfAbout && "footer-heading-extra-padding"
                  }`}
                >
                  <span>About</span>
                  <span>
                    {!ListOfAbout ? <DownOutlined /> : <UpOutlined />}
                  </span>
                </div>
                {ListOfAbout === true ? <>{About}</> : null}
              </div>
              <div className="footer-Support-section">
                <div
                  onClick={() => SetListOfSupport(!ListOfSupport)}
                  className={`footer-heading ${
                    ListOfSupport && "footer-heading-extra-padding"
                  }`}
                >
                  <span>Support</span>
                  <span>
                    {!ListOfSupport ? <DownOutlined /> : <UpOutlined />}
                  </span>
                </div>
                {ListOfSupport === true ? <>{Support}</> : null}
              </div>
              <div className="footer-Community-section">
                <div
                  onClick={() => SetListOfCommunity(!ListOfCommunity)}
                  className={`footer-heading ${
                    ListOfCommunity && "footer-heading-extra-padding"
                  }`}
                >
                  <span>Community</span>
                  <span>
                    {!ListOfCommunity ? <DownOutlined /> : <UpOutlined />}
                  </span>
                </div>
                {ListOfCommunity === true ? <>{Community}</> : null}
              </div>
              <div className="footer-Community-section">
                <div
                  onClick={() => SetListOfMoreFromUs(!ListOfMoreFromUs)}
                  className={`footer-heading ${
                    ListOfMoreFromUs && "footer-heading-extra-padding"
                  }`}
                >
                  <span>More from us</span>
                  <span>
                    {!ListOfMoreFromUs ? <DownOutlined /> : <UpOutlined />}
                  </span>
                </div>
                {ListOfMoreFromUs === true ? <>{MoreFromUs}</> : null}
              </div>
            </div>
          </>
        ) : (
          <div className="footer-section">
            <div className="footer-About-section">
              <div className="footer-heading">About</div>
              {About}
            </div>
            <div className="footer-Support-section">
              <div className="footer-heading">Support</div>
              {Support}
            </div>
            <div className="footer-Community-section">
              <div className="footer-heading">Community</div>
              {Community}
            </div>
            <div className="footer-Community-section">
              <div className="footer-heading">More from us</div>
              {MoreFromUs}
            </div>
          </div>
        )}
        <Divider />
        <div className="footer-logo-section">
          <div className="Footer-logo-Skillgig">
            <img src={Logo2} />
            <span>© SkillGigs {new Date().getFullYear()}</span>
          </div>
          <div className="footer-social-link">
            <a href="https://www.facebook.com/skillgigsonline/" target="_blank">
              <span>
                <BsFacebook className="footer-icon-modifiction" />
              </span>
            </a>
            <a href="https://www.instagram.com/skillgigs" target="_blank">
              <span>
                <InstagramOutlined className="footer-icon-modifiction" />
              </span>
            </a>
            <a
              href="https://www.linkedin.com/company/skillgigs"
              target="_blank"
            >
              <span>
                <BsLinkedin className="footer-icon-modifiction" />
              </span>
            </a>
            <a
              href="https://twitter.com/skillgigsonline?lang=en"
              target="_blank"
            >
              <span>
                <TwitterOutlined className="footer-icon-modifiction" />
              </span>
            </a>
            <a
              href="https://open.spotify.com/show/0Hv4UfacP60hX8JM7a69k0"
              target="_blank"
            >
              <span>
                <BsSpotify className="footer-icon-modifiction" />
              </span>
            </a>
            <a
              href="https://www.youtube.com/channel/UC3e1p8j1onjj7sDH2Z_1JAA"
              target="_blank"
            >
              <span>
                <BsYoutube className="footer-icon-modifiction" />
              </span>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
